import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/insurance/new-bg.png'
import _imports_1 from '@/assets/img/insurance/hot.png'


const _withScopeId = n => (_pushScopeId("data-v-0d6057ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-box block" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "开通保险方案", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "describe" }, "方案开通后，请至保险方案下进行人员投保操作", -1))
const _hoisted_4 = { class: "btn-check" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "difference link" }, "有什么区别？", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tip-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "vertical" }),
    /*#__PURE__*/_createTextVNode(" 灵活保单 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "tip-content" }, " 按天计费，每日凌晨按在保人员扣除当天的保费（请确保账户余额足够），员工可随时减保员工每月自动续保，直到您主动减保 "),
  /*#__PURE__*/_createElementVNode("div", { class: "line" }),
  /*#__PURE__*/_createElementVNode("div", { class: "tip-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "vertical" }),
    /*#__PURE__*/_createTextVNode(" 月保单 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "tip-content" }, " 每月1-15日加保算一个月费用，16日-月底加保算半个月费用。保障期间人员只能交换，不能减保每月底需手工续保，并缴纳下月费用 ")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bg",
  src: _imports_0
}, null, -1))
const _hoisted_8 = { class: "plan-head" }
const _hoisted_9 = { class: "plan-title" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "plan-body" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_14 = { class: "plan-detail" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-check" }, null, -1))
const _hoisted_16 = { class: "plan-advantage-text" }
const _hoisted_17 = { class: "plan-advantage-describe" }
const _hoisted_18 = {
  key: 0,
  src: _imports_1,
  class: "plan-hot"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_head = _resolveComponent("page-head")!
  const _component_tab_capsule = _resolveComponent("tab-capsule")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_page_head, { title: "开通新方案" }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_tab_capsule, {
          list: _ctx.type,
          active: _ctx.typeActive,
          onTabchange: _ctx.onInsuranceTab
        }, null, 8, ["list", "active", "onTabchange"]),
        _createVNode(_component_el_popover, {
          placement: "bottom-end",
          width: "350px",
          trigger: "click"
        }, {
          reference: _withCtx(() => [
            _hoisted_5
          ]),
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _hoisted_7,
      _createVNode(_component_el_scrollbar, { class: "container-plan" }, {
        default: _withCtx(() => [
          (_ctx.data.length === 0)
            ? (_openBlock(), _createBlock(_component_el_empty, { key: 0 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "plan-box",
            style: _normalizeStyle({ width: 348 * _ctx.data.length + 'px' })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass({
                        plan: true,
                        month: item.type === '月保单'
                    }),
                key: index
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("img", {
                      src: item.logo,
                      class: "plan-logo"
                    }, null, 8, _hoisted_10),
                    _createElementVNode("span", null, _toDisplayString(item.name), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    class: "plan-btn btn",
                    onClick: ($event: any) => (_ctx.onOpenPlan(item.plan_id))
                  }, " 立即开通 ", 8, _hoisted_12),
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.feature, (i, k) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "plan-advantage",
                        key: k
                      }, [
                        _hoisted_15,
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", null, _toDisplayString(i.title), 1),
                          _createElementVNode("div", _hoisted_17, _toDisplayString(i.desc), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                (item.is_hot)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ], 4)
        ]),
        _: 1
      })
    ])
  ], 64))
}